function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6386 5.64917H17.4036C21.0358 5.64917 22.4031 7.48914 22.1918 10.1923C21.8426 14.6551 19.1464 17.1241 15.57 17.1241H13.7644C13.2737 17.1241 12.9437 17.4491 12.811 18.3298L12.0444 23.4495C11.9937 23.7815 11.8191 23.9737 11.5572 24H7.3068C6.90691 24 6.76546 23.6942 6.87024 23.0319L9.46167 6.61896C9.56295 5.96195 9.92268 5.64917 10.6386 5.64917Z",
  fill: "#009EE3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.40723 0H13.1792C15.0861 0 17.3492 0.0611576 18.8615 1.39789C19.8725 2.29079 20.4034 3.71139 20.2812 5.24208C19.8656 10.416 16.773 13.3149 12.6239 13.3149H9.28505C8.71577 13.3149 8.34033 13.6923 8.17967 14.7128L7.24718 20.6538C7.18606 21.0382 7.02017 21.2654 6.7233 21.2933H2.54454C2.08178 21.2933 1.91763 20.9439 2.03812 20.1715L5.04167 1.12879C5.16216 0.36345 5.58301 0 6.40723 0Z",
  fill: "#113984"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.27734 14.1099L9.45955 6.619C9.56258 5.96199 9.92231 5.64746 10.6383 5.64746H17.4032C18.5226 5.64746 19.4289 5.8222 20.1379 6.14546C19.4586 10.7515 16.4812 13.3096 12.5836 13.3096H9.25C8.80297 13.3114 8.47467 13.5351 8.27734 14.1099Z",
  fill: "#172C70"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgPaypal = function SvgPaypal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaypal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paypal.ba3b2a42.svg";
export { ForwardRef as ReactComponent };